export enum LanguagesEnum {
    PORTUGUESE = 'pt-br',
    ENGLISH = 'en',
    SPANISH = 'es'
}